var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isSimulation)?_c('SimulationDetailDrawer'):(_vm.isCoverage || _vm.isFormation)?_c('CoverageDetailDrawer'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }